<template>
 
  <div id="app" v-if="!isMobile"  style="width: 100vw;height: 100vh;overflow-x: hidden;">
    <img src="../../public/1.png" alt="" style="width:100%">
    <img src="../../public/2.png" alt="" style="width:100%">
    <img src="../../public/3.png" alt="" style="width:100%">
    <img src="../../public/4.png" alt="" style="width:100%">
    <div class="newblackdiv" style="background-color: #292f33;">
      <div style="display: flex;color:white;justify-content: space-evenly;font-size: 0.75vw;">
       
         <div style="">
          <div style="display: flex;flex-direction: column;    width: 24vw;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备18144595号-2</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >深圳游点好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>深圳市南山区崇文花园4号办公楼807</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>ball.youdianhaowan.com</div>
            </div>
          </div>
      </div>
      </div>
       
      <div style="border: 0.1px solid #404040;margin: 40px 0;margin-bottom: 20px;"></div>
      <div  v-if="isEnglish" class="bottom">ball.youdianhaowan.com Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
      <div v-else class="bottom">ball.youdianhaowan.com 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
    </div>





  

  </div>
  <div id="app" v-else  style="width: 100vw;height: 100vh;overflow-x: hidden;">
    <img src="../../public/1.png" alt="" style="width:100%">
    <img src="../../public/2.png" alt="" style="width:100%">
    <img src="../../public/3.png" alt="" style="width:100%">
    <img src="../../public/4.png" alt="" style="width:100%">
    <div class="phonenewblackdiv" style="background-color: #292f33;">
          <div style="display: flex;flex-direction: column;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备18144595号-2</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish" style="text-align: right;">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >深圳游点好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>深圳市南山区崇文花园4号办公楼807</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>ball.youdianhaowan.com</div>
            </div>
          </div>
       
      <div style="border: 0.1px solid #404040;    margin: 10px 0;"></div>
      <div v-if="isEnglish" class="bottom" style="font-size: 12px;margin-bottom: 20px;"> Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>

      <div v-else class="bottom" style="font-size: 12px;margin-bottom: 20px;"> 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备18144595号-2</a></div>
    </div>
  </div>
 
</template>

<script>
 import MobileDetect from 'mobile-detect';
export default {
  name: 'App',
  
  data() {
    return {
      isMobile: false,
      isEnglish: false,
    };
  },
  mounted() {
    this.detectDevice();
  },
  methods: {
    detectDevice() {
      const md = new MobileDetect(window.navigator.userAgent);
      this.isMobile = md.mobile(); // 或者使用 md.tablet() 来检测平板设备
    },
    handleLanguageUpdate(newLanguage) {
      this.isEnglish = newLanguage
      // 处理语言切换逻辑，例如更新页面内容或调用其他方法
      console.log('Language updated:', newLanguage); 
    }
  }
};
</script>

<style>
.bottom{
    color: #ffffff;
  font-size: 14px;
      display: flex;
    justify-content: center;
}

.blackdiv{
  background: #1a1a1a;
  display: flex;
  padding: 100px 18%;
  justify-content: space-between;
 
}
.phoneblackdiv{
   background: #1a1a1a;
  display: flex;
  padding: 50px 18%;
  justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.newblackdiv{
    background: #1a1a1a;
  padding: 150px 18%;
  padding-bottom: 1vw;

}

.phonenewblackdiv{
    background: #1a1a1a;
  padding: 20px 18%;
  padding-bottom: 1vw;
  font-size: 12px;
  color: white;
}


  .midfontdes{
    font-size: 1.1rem;
    font-weight: 400;
    color: #999999 !important;
    padding: 50px 0  ;
  }
  .phoneidfontdes{
    font-size: 14px;
    font-weight: 400;
    color: #999999 !important;
    /* padding: 50px 0  ; */
  }
 .gamelistlogo{
  display: flex;
  padding-bottom: 100px;
 }
 .gamelistlogoinfo{
 width: 13vw;
 
  margin:15px;
 }
  .phonegamelistlogo{
  display: flex;
  padding-bottom: 60px;
  flex-wrap: wrap;
    width: 70vw;
 }
  .phonegamelistlogoinfo{
 width: 26vw;
 
  margin:15px;
 }
.yellowdiv{
  width: 100%;
  display: flex;
  background: #fac422;
  flex-direction: column;
    align-items: center
}

.rightphoto{
  position: absolute;
    left: 48%;
    top: 15vh;
    width: 50vw;
}
.fontdes{
 font-size: 1.125rem;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 0 15vw;
}

.phonefontdes{
 font-size: 14px;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 50px 15vw;
}


.fontpng{
      width: 25vw
}
.phonefontpng{
      width: 50vw
}
.imgphoto{
  padding: 25vh 20px 0 10vw;
  display: flex;
      justify-content: space-between;
}

.phoneimgphoto{
  padding: 5vh 20px 0 10vw;
  display: flex;
  justify-content: space-around;
}
.logopng{
     width: 10vw;
    height: 100%;
}
.phonelogopng{
     width: 18vw;
    height: 100%;
}
.topclass{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
}
/* 根据需要添加全局样式 */
.topleft{
  background-color: #000000;
    width: 55%;
      height: 100%;
}

.phonetopleft{
  background-color: #000000;
}
.topright{
  background-color: #57bbff;
   width: 45%;
     height: 100%;
}

 

</style>
